export const DEFAULT_METRICS_CONFIGS = [
  {
    metric: "activated_afrr",
    range_min: -2.5,
    range_max: 2.5,
  },
  {
    metric: "active_power_mw",
    range_min: -1.25,
    range_max: 1.25,
  },
  {
    metric: "afrr_baseline",
    range_min: -1.25,
    range_max: 1.25,
  },
  {
    metric: "afrr_down_maintained_capacity",
    range_min: 0,
    range_max: 2.5,
  },
  {
    metric: "afrr_up_maintained_capacity",
    range_min: 0,
    range_max: 2.5,
  },
  {
    metric: "fcrd_down_capacity",
    range_min: 0,
    range_max: 1.25,
  },
  {
    metric: "fcrd_up_capacity",
    range_min: 0,
    range_max: 1.25,
  },
  {
    metric: "fcrn_capacity",
    range_min: 0,
    range_max: 1.25,
  },
  {
    metric: "ffr_capacity",
    range_min: 0,
    range_max: 1.25,
  },
  {
    metric: "setpoint_power_mw_fcrd_down",
    range_min: -1.25,
    range_max: 1.25,
  },
  {
    metric: "setpoint_power_mw_fcrd_up",
    range_min: -1.25,
    range_max: 1.25,
  },
  {
    metric: "setpoint_power_mw_fcrn",
    range_min: -1.25,
    range_max: 1.25,
  },
  {
    metric: "fcrn_endurance",
    range_min: 0,
    range_max: 0,
  },
  {
    metric: "fcrd_up_endurance",
    range_min: 0,
    range_max: 0,
  },
  {
    metric: "fcrd_down_endurance",
    range_min: 0,
    range_max: 0,
  },
];
